import * as api from '../../constants/api'
import callApi from '../http'

const petrolStationRefuelTankerByOperator = async (body) => await callApi(api.REFUELING_TANKER, body)

const petrolStationList = async (body) => await callApi(api.PETROL_STATION, body)

const petrolStationRefuelTankerAdd = async (body) => await callApi(api.REFUELING_TANKER_ADD, body)

const petrolStationRefuelTankerUpdate = async (body) => await callApi(api.REFUELING_TANKER_UPDATE, body)

const fuelCarProbe = async (body) => await callApi(api.FUEL_CAR_PROBE, body)

export {
    fuelCarProbe,
    petrolStationList,
    petrolStationRefuelTankerAdd,
    petrolStationRefuelTankerUpdate,
    petrolStationRefuelTankerByOperator,
}